export default __webpack_public_path__ + "static/media/buddy.66ae4b2a.svg";